import React,{ Component } from "react";
import ReactTable from "react-table";


class LogTable extends Component {

     constructor(props) {
        super(props);
    }

    render() {

        const {columns, logs, loading} = this.props;
        if (columns && logs && logs.data && !loading) {
            return <ReactTable
                columns={columns}
                data={logs.data}
                loading={loading}
                // filterable
                defaultPageSize={100}
                pageSizeOptions={[20, 50, 100, 250, 500, 1000]}
                getTrProps={(state, rowInfo) => {
                    if (rowInfo === undefined) {
                        return {}
                    }
                    return {
                        'data-qnt': rowInfo.original ? "1" : "0",
                        'data-value': rowInfo.original.levelname,
                        'data-allow':rowInfo.original.allow ? rowInfo.original.allow : "0"
                    }
                }}
                SubComponent={row => {
                    let text = row && row.original && Object.entries(row.original).map(([key, data]) => {
                            let error;
                            if (key === 'traceback' && data !== null) {
                                error = data.split('\n').map((item, i) => {
                                    return <div className="text-danger" key={i}>{item}<br/></div>
                                });
                            }
                            return <div>
                                { data !== null ?
                                    <div>
                                        <span className="text-primary">{key}:</span> {error ? error : data}
                                    </div>
                                    : ''}
                            </div>
                        });
                    return (
                        <div className="pl-5">{text}</div>
                    );
                }}
                className="-striped -highlight"
            />
        }
        return '';

    }
}



export default LogTable;



// WEBPACK FOOTER //
// ./src/components/LogTable/LogTable.js